export default __webpack_public_path__ + "static/media/topitemNail.50a4579f.png";